














import {Vue, Component, Prop} from "vue-property-decorator";
import {DefaultColor} from "@/modules/constants";

@Component
export default class CardIcon extends Vue {
    @Prop({default: "24px"})
    height!: string;

    @Prop({default: "24px"})
    width!: string;

    @Prop({default: false, type: Boolean})
    small!: boolean;

    @Prop({default: DefaultColor})
    color!: string;

    get h() {
      return this.small ? "16px" : this.height;
    }

    get w() {
      return this.small ? "16px" : this.width;
    }
}
